<div class="labels-container">
  <div class="labels-chips">
    @for (label of assignedLabels; track label.id) {
    <span class="label-chip" [style.--label-color]="label.color">
      <span class="chip-dot" [style.background]="label.color"></span>
      <span class="chip-name">{{ getLabelDisplayName(label) }}</span>
      @if (label.is_standard && !label.is_system) {
      <span class="chip-lock" [title]="t('LABEL_STANDARD', 'Standard label')">
        <!-- <i class="pi pi-lock"></i> -->
      </span>
      }
      @if (label.is_system) {
      <span class="chip-lock" [title]="t('LABEL_SYSTEM', 'Applied automatically - only an admin can remove this')">
        <i class="pi pi-lock"></i>
      </span>
      } @else {
      <button class="chip-remove" (click)="removeLabel(label)" type="button"
        [title]="t('LABEL_REMOVE', 'Remove label')">
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 1l6 6M7 1L1 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
      </button>
      }
    </span>
    }

    <button #addTrigger class="add-label-trigger" (click)="toggleDropdown()" type="button">
      <i class="pi pi-plus"></i>
      {{ t('LABEL_ADD', 'Add label') }}
    </button>
  </div>

  @if (dropdownOpen) {
  <div class="label-dropdown" [style.top.px]="dropdownTop" [style.left.px]="dropdownLeft">
    <div class="dropdown-search">
      <i class="pi pi-search"></i>
      <input type="text" [(ngModel)]="searchQuery"
        [placeholder]="t('LABEL_SEARCH', 'Search labels...')"
        autofocus />
    </div>

    <div class="dropdown-list">
      @for (label of filteredAvailable; track label.id) {
      <button class="dropdown-item" (click)="assignLabel(label)" type="button">
        <span class="item-dot" [style.background]="label.color"></span>
        <span class="item-name">{{ getLabelDisplayName(label) }}</span>
        @if (label.is_standard) {
        <i class="pi pi-lock item-lock" [title]="t('LABEL_STANDARD', 'Standard label')"></i>
        }
      </button>
      }
      @if (filteredAvailable.length === 0 && !creating) {
      <div class="dropdown-empty">{{ t('LABEL_NO_MATCH', 'No labels found') }}</div>
      }
    </div>

    @if (creating) {
    <div class="create-form">
      <input type="text" [(ngModel)]="newLabelName" maxlength="50"
        [placeholder]="t('LABEL_NAME_PLACEHOLDER', 'Label name')" autofocus />
      <div class="color-palette">
        @for (color of presetColors; track color) {
        <button class="color-swatch" [style.background]="color"
          [class.selected]="newLabelColor === color"
          (click)="newLabelColor = color" type="button">
          @if (newLabelColor === color) { <i class="pi pi-check"></i> }
        </button>
        }
      </div>
      <div class="create-actions">
        <button class="btn-cancel" (click)="cancelCreate()" type="button">
          {{ t('LABEL_CANCEL', 'Cancel') }}
        </button>
        <button class="btn-save" (click)="saveNewLabel()"
          [disabled]="!newLabelName.trim() || saving" type="button">
          {{ saving ? t('LABEL_SAVING', 'Saving...') : t('LABEL_SAVE', 'Save') }}
        </button>
      </div>
    </div>
    } @else {
    <button class="dropdown-create-btn" (click)="startCreate()" type="button">
      <i class="pi pi-plus"></i>
      {{ t('LABEL_CREATE_NEW', 'Create new label') }}
    </button>
    }
  </div>
  }
</div>
